<svg
  class="progress-ring"
  width="22"
  height="22"
  viewBox="0 0 22 22"
  aria-hidden="true"
>
  <circle
    class="progress-ring-track"
    cx="11"
    cy="11"
    [attr.r]="radius"
  ></circle>
  <circle
    class="progress-ring-fill"
    cx="11"
    cy="11"
    [attr.r]="radius"
    [attr.stroke-dasharray]="circumference"
    [attr.stroke-dashoffset]="dashOffset"
  ></circle>
</svg>
